import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const ContentRow = dynamic(async () => {
  return (await import("./ContentRow")).default;
});

Builder.registerComponent(ContentRow, {
  name: "Content Row",
  inputs: [
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Oat",
      enum: toolkitColors,
      helperText: "Background color to be added for the Content Row",
    },
    {
      name: "contentHeading",
      type: "string",
      helperText:
        "Heading text to be added for the Content Row (Character limit - 25)",
      onChange: `if(options.get("contentHeading").length > 25) {options.set("contentHeading", options.get("contentHeading").slice(0, 25));alert("Maximum number of characters is 25")}`,
    },
    {
      name: "contentCTAText",
      type: "string",
      helperText:
        "CTA text to be added for the Content Row (Character limit - 25)",
      onChange: `if(options.get("contentCTAText").length > 25) {options.set("contentCTAText", options.get("contentCTAText").slice(0, 25));alert("Maximum number of characters is 25")}`,
    },
    {
      name: "contentCTAUrl",
      type: "url",
      helperText: "CTA destination url",
    },
    {
      name: "zoomEffect",
      type: "boolean",
      defaultValue: true,
      helperText:
        "Turn this on to enable the zoom effect on image cards",
    },
    {
      name: "textColor",
      type: "boolean",
      defaultValue: false,
      helperText:
        "Turn this on to make text and arrow color white",
    },
    {
      name: "contentCards",
      type: "list",
      subFields: [
        {
          name: "heading",
          type: "string",
          helperText:
            "Heading text to be added for the Story Card (Character limit - 25)",
          onChange: `if(options.get("heading").length > 25) {options.set("heading", options.get("heading").slice(0, 25));alert("Maximum number of characters is 25")}`,
        },
        {
          name: "body",
          type: "longText",
          helperText:
            "Body text to be added for the Story Card (Character limit - 200)",
          onChange: `if(options.get("body").length > 200) {options.set("body", options.get("body").slice(0, 200));alert("Maximum number of characters is 200")}`,
        },
        {
          name: "storyCardImage",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          helperText: "Story Card Image Desktop",
          required: true,
        },
        {
          name: "storyAltText",
          type: "string",
          helperText: "Image alt text",
        },
        {
          name: "storyCardImageTablet",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          helperText: "Story Card Image Tablet",
          required: true,
        },
        {
          name: "storyCardImageMobile",
          type: "file",
          allowedFileTypes: ["jpeg", "png", "gif"],
          helperText: "Story Card Image Mobile",
          required: true,
        },
        {
          name: "CTAText",
          type: "string",
          helperText:
            "CTA text to be added for the Story Card (Character limit - 25)",
          onChange: `if(options.get("CTAText").length > 25) {options.set("CTAText", options.get("CTAText").slice(0, 25));alert("Maximum number of characters is 25")}`,
          required: true,
        },
        {
          name: "CTAUrl",
          type: "url",
          helperText: "CTA destination url",
        },
      ],
    },
  ],
});
